interface Settings {
    INNO_BASE_PATH: string;
    INNO_IS_INTERNAL_USER?: number;
}
class GlobalSettings {
    private settings: Settings;

    public GetSettings = () => {
        return this.settings;
    }

    public SetSettings = (settings: any) => {
        this.settings = settings;
    }
}
var globalSettingsSingleton: GlobalSettings = new GlobalSettings();

export var getGlobalSettings = (): GlobalSettings => {
    return globalSettingsSingleton;
}